import http from "../http/http-config";
import { Vigency } from "../models/Vigency";

export default new class validateVigencyService {
    validateVigency(startDate, endDate, productId): Promise<Vigency> {
        return http.get<Vigency>("ValidateVigency", {
            params: {
                StartDate: startDate,
                ExpirationDate: endDate,
                ProductId: productId
            }
        }).then(response => response.data)
    }    
}